import { FC } from 'react';
import { FormValue } from '@app/shared/components/form-controls/form-value/FormValue';
import {
  amountBasicFieldFormattingProps,
  numericBasicFieldFormattingProps,
} from '@app/shared/components/form-controls/form-field/form-field-patterns';
import { ReadOnlyCellProps } from './types';

const returnNullIfZero = (value: number | null | undefined): number | null | undefined => {
  return value === 0 ? null : value;
};

const ReadOnlyTableCell: FC<ReadOnlyCellProps> = ({ value, isAmountField }) => (
  <td>
    <FormValue
      value={returnNullIfZero(value)}
      {...(isAmountField ? amountBasicFieldFormattingProps : numericBasicFieldFormattingProps)}
      autoHeight
    />
  </td>
);

export default ReadOnlyTableCell;
